module.exports = __webpack_public_path__ + "img/jet5_feature_01.17d00df9.jpg";